import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { ErrorMessageModule } from '../error-message/error-message.module';
import { TooltipMessageModule } from '../tooltip-message/tooltip-message.module';
import { TextArea } from '../utils/models/TextArea';
import { TextAreaComponent } from './text-area.component';
import { TextAreaService } from './text-area.service';


@NgModule({
  declarations: [TextAreaComponent],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    ErrorMessageModule,
    TooltipMessageModule
  ],
  exports: [TextAreaComponent]
})
export class TextAreaModule {
  static forRoot(textArea: TextArea = new TextArea()): ModuleWithProviders<TextAreaModule> {
    return {
      ngModule: TextAreaModule,
      providers: [
        { provide: 'TEXT_AREA_FORMAT', useValue: textArea.format },
        { provide: 'TEXT_AREA_SHOW_LABEL', useValue: textArea.showLabel },
        { provide: 'TEXT_AREA_VALIDATOR_MESSAGE', useValue: textArea.validatorMessage },
        { provide: 'TEXT_AREA_TOOLTIP_MESSAGE', useValue: textArea.tooltipMessage },
        { provide: 'TEXT_AREA_SUBMITTED', useValue: textArea.submitted },
        { provide: 'TEXT_AREA_VALIDATOR_ALERT', useValue: textArea.validatorAlert },
        TextAreaService
      ]
    }
  }
 }
